import {clsx} from 'clsx';
import React from 'react';
import {useNumberFormatter} from 'react-aria';

const formatting = {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  signDisplay: 'exceptZero',
} as const;

type DiffDeltaProps = {
  color: 'added' | 'removed';
  size: 'md' | 'sm';
  value: number;
};

/**
 * This recapitulates the behavior of @wandb/components MetricDelta component,
 * but with green/red coloring rather than teal/sienna coloring. This brings it
 * in line with the add/remove coloring within the patch viewer.
 */
function DiffDelta({color, size, value}: DiffDeltaProps) {
  const formatter = useNumberFormatter(formatting);
  const cls = clsx('block rounded-sm font-mono whitespace-nowrap', {
    'bg-wb-success-bg text-wb-success-text': color === 'added',
    'bg-wb-error-bg text-wb-error-text': color === 'removed',
    'text-xs px-2 py-2': size === 'sm',
    'text-sm px-4 py-4': size === 'md',
  });
  return <data className={cls}>{formatter.format(value)}</data>;
}

type PatchDeltaProps = {
  adds: number;
  dels: number;
  size?: 'md' | 'sm';
};
export function PatchDelta({adds, dels, size = 'md'}: PatchDeltaProps) {
  return (
    <>
      {adds > 0 ? <DiffDelta color="added" size={size} value={adds} /> : null}
      {dels > 0 ? (
        <DiffDelta color="removed" size={size} value={dels * -1} />
      ) : null}
    </>
  );
}
